import LocalizationsService from '@/services/LocalizationsService';
import AuthenticationService from '@/services/AuthenticationService';
import UsersService from '@/services/UsersService';

import _ from 'lodash';
import { i18n, changeLocalization } from '@/i18n';

const state = {
  localizations: {},
  currentLocale: null, // Speichere Locale-String (z.B. 'de-DE')
  loading: false,
  error: null
};

const getters = {
  localizations: state => state.localizations,
  currentLocale: state => state.currentLocale || i18n.global.locale,
  currentLocaleValue: state => i18n.global.locale.value, // Für Vue 3 Ref
  currentLocalization: state => {
    // Gibt das vollständige Localization-Objekt zurück
    return state.currentLocale ? state.localizations[state.currentLocale] : null;
  },
  isLoadingLocalizations: state => state.loading,
  error: state => state.error
};

const mutations = {
  SET_LOCALIZATIONS(state, localizations) {
    state.localizations = localizations;
  },
  SET_CURRENT_LOCALE(state, locale) {
    state.currentLocale = locale;
    // Vue 3: locale ist eine Ref, daher .value verwenden
    if (i18n.global.locale.value !== undefined) {
      i18n.global.locale.value = locale;
    } else {
      // Fallback für Vue 2.7 Compat Mode
      i18n.global.locale = locale;
    }
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  }
};

const actions = {
  async fetchLocalizations({ commit }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);

    try {
      const response = await LocalizationsService.getLocalizationTexts();

      const processedLocalizations = _(response.data)
        .filter(element =>
          element.localizationTextId !== "deflt" ||
          AuthenticationService.isMSMUser
        )
        .groupBy("localizationTextId")
        .mapValues(elements => {
          return elements.sort((a, b) => {
            if (a.localizationId === "en-GB") return 1;
            else if (b.localizationId === "en-GB") return -1;
            else return 0;
          });
        })
        .value();

      commit('SET_LOCALIZATIONS', processedLocalizations);

      // Setze aktuelle Locale (als String!)
      const currentLocale = i18n.global.locale.value || i18n.global.locale;
      commit('SET_CURRENT_LOCALE', currentLocale);

      return processedLocalizations;
    } catch (error) {
      log.error('STO: Error fetching localizations:', error);
      commit('SET_ERROR', error);
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async updateCurrentLocalization({ commit, state }, locale) {
    // Validiere dass die Locale existiert
    if (!state.localizations[locale]) {
      log.warn(`STO: Locale ${locale} not found in localizations`);
      return;
    }
    await UsersService.setUserProfile({ LocalizationId: locale });
    await changeLocalization(locale);
    commit('SET_CURRENT_LOCALE', locale);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
